import type { PropsWithChildren } from "react";
import useClientContext from "../../../context/useClientContext";
import type { Props } from "./ObjectDefinitionContext";
import { ObjectDefinitionContext } from "./ObjectDefinitionContext";

export const ObjectDefinitionContextProvider = ({
  objectDefinition,
  onUpdateObjectDefinition,
  configurations,
  allObjectDefinitions,
  children,
}: PropsWithChildren<Props>) => {
  const { hasPermissions } = useClientContext();

  const hasEditPermissions = hasPermissions(["ManageOrganizationDataModel"]);

  return (
    <ObjectDefinitionContext
      value={{
        objectDefinition,
        onUpdateObjectDefinition,
        configurations,
        allObjectDefinitions,
        hasEditPermissions,
      }}
    >
      {children}
    </ObjectDefinitionContext>
  );
};
